import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import config from '../../../../config.js';
import { capitalizeFirstLetter } from '../../../../util/text.js';

import { getLanguagePath } from '../../../Intl/IntlHelper.js';
import { getPanelBySlugAndLanguage, getContentBlockItemValue, memoizedGetPanelBySlugAndLanguage } from '../../../Cms/CmsActions.js';

import withRouter from '../../../../components/Router/WithRouter.js';
import withIntl from '../../../../components/Intl/WithIntl.js';
import PredictiveLink from '../../../Cms/components/view/PredictiveLink.js';

function Breadcrumbs({ location, intl, crumbs = [], breadcrumbBaseAnchorPanel = null }) {
	const breadcrumbBaseAnchor = breadcrumbBaseAnchorPanel && getContentBlockItemValue(breadcrumbBaseAnchorPanel.blocks, 'text');

	// console.log(location, location.pathname.split('/'));
	// Enabled on all pages except home & cart
	const pathParts = location.pathname.split('/').filter(part => part);
	const isEnabled = pathParts.length > 0;

	pathParts.shift();

	let resolvedCrumbs = crumbs;
	if(!resolvedCrumbs || !resolvedCrumbs.length) {
		if(typeof window !== 'undefined' && window.document) {
			const titleParts = `${window.document.title}`.split('-');
			titleParts.pop();
			resolvedCrumbs = [titleParts.join('-')];
		} else {
			resolvedCrumbs = [capitalizeFirstLetter(pathParts.join(' ').replace(/-/g, ' '))];
		}
	}

	const renderCrumb = (crumb, index) => {
		return (
			<span key={index}>
				{
					typeof crumb === 'object'
						? <a href={crumb.path} className={classnames(index + 1 === resolvedCrumbs.length && 'text-secondary')}>{crumb.text}</a>
						: <span className={classnames(index + 1 === resolvedCrumbs.length && 'text-secondary')}>{crumb}</span>
				}
				{index + 1 < resolvedCrumbs.length && ' > '}
			</span>
		);
	};

	if(isEnabled && resolvedCrumbs?.length > 0) {
		return (
			<Fragment>
				<div className="breadcrumbs p-2 text-primary">
					<a href={getLanguagePath('/', intl.locale)} className="">{breadcrumbBaseAnchor || <FormattedMessage id="appHome" defaultMessage="Home" />}</a>
					{' > '}
					{resolvedCrumbs.map(renderCrumb)}
				</div>
			</Fragment>
		);
	}
	return null;
}

function mapStateToProps(store, props) {
	return {
		breadcrumbBaseAnchorPanel: memoizedGetPanelBySlugAndLanguage(store, 'breadcrumb-base-anchor', (store.intl || {}).locale),
	};
}

Breadcrumbs.propTypes = {
	location: PropTypes.object.isRequired,
	intl: PropTypes.object.isRequired,
	crumbs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
	breadcrumbBaseAnchorPanel: PropTypes.object,
};

export default connect(mapStateToProps)(withRouter(withIntl(Breadcrumbs)));
